import { Injectable } from "@angular/core";

export type HighlightTheme =
  | "theme-select--1"
  | "theme-select-0"
  | "theme-select-1"
  | "theme-select-2"
  | "theme-select-3"
  | "theme-select-4"
  | "theme-select-5"
  | "theme-select-6";

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  private readonly storageKey = "highlight-theme";

  private readonly themes: HighlightTheme[] = [
    "theme-select--1",
    "theme-select-0",
    "theme-select-1",
    "theme-select-2",
    "theme-select-3",
    "theme-select-4",
    "theme-select-5",
    "theme-select-6",
  ];

  initTheme(): void {
    const savedTheme = localStorage.getItem(
      this.storageKey,
    ) as HighlightTheme | null;

    if (savedTheme && this.themes.includes(savedTheme)) {
      this.setHighlightTheme(savedTheme);
    } else {
      this.setHighlightTheme("theme-select-4");
    }
  }

  setHighlightTheme(theme: HighlightTheme): void {
    document.body.classList.remove(...this.themes);
    document.body.classList.add(theme);

    localStorage.setItem(this.storageKey, theme);
  }

  getCurrentTheme(): HighlightTheme {
    return (
      (localStorage.getItem(this.storageKey) as HighlightTheme | null) ??
      "theme-select-4"
    );
  }
}
